import { render, staticRenderFns } from "./SidBackgroundFilters.vue?vue&type=template&id=33bf2e7d"
import script from "./SidBackgroundFilters.vue?vue&type=script&lang=js"
export * from "./SidBackgroundFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports